module.exports = __webpack_public_path__ + "img/pr-3.37352660.png";